import { render } from "./new-channel-selector-form.vue?vue&type=template&id=c53324ee&lang=pug"
import script from "./new-channel-selector-form.vue?vue&type=script&lang=js"
export * from "./new-channel-selector-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__